import { Box, Button, Link, Stack } from "@mui/material";
import React from "react";

export default function PresentationNavigation(props) {
  return (
    <Box
      sx={{
        display: "flex",
        // justifySelf: "center",
        justifyContent: "center",
        justifyItems: "center",
      }}
    >
      <Stack spacing={1}>
        <Link href="/portfolio">
          <Button
            variant="contained"
            size="small"
            color="primary"
            sx={{ width: "30vh" }}
          >
            view our gallery
          </Button>
        </Link>
        <Link href="/about">
          <Button
            variant="contained"
            size="small"
            color="secondary"
            sx={{ width: "30vh" }}
          >
            get a quote
          </Button>
        </Link>
      </Stack>
    </Box>
  );
}
